import { render } from "./projects-tab.vue?vue&type=template&id=69db97c3"
import script from "./projects-tab.vue?vue&type=script&lang=js"
export * from "./projects-tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__